/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
import { Box, IconButton, Typography } from '@mui/material';
import React, {  useEffect, useRef, useState } from 'react';
import { AuthSubtitle, AuthTitle } from '../index.styles';
import * as Yup from 'yup';
import { Formik, FormikProps } from 'formik';
import AuthInput from 'features/auth/components/authInput';
import AuthButton from 'features/auth/components/authSubmitButton';
import { styled } from '@mui/system';
import FormikErrorFocus from 'formik-error-focus';
import { KeyboardBackspace } from '@mui/icons-material';
import {  BrandSignUpFormBody, CreatorSignUpFormBody, formatTime } from 'features/auth/utilites';
import { connect } from 'react-redux';
import { IState } from 'shared/utilities/interfaces';
import { getVerifyOtpAction, resendOtpAction } from 'features/auth/store/actions';
import { history } from 'store/store';
import { getSessionStoreage } from 'shared/helpers/auth.helper';
import { makeStyles } from '@mui/styles';

interface ICreatorOtpVerify {
    userPayload: BrandSignUpFormBody | CreatorSignUpFormBody,
    getVerifyOtp: any
    resendOtpApi:any
}



function OtpVerify(creatorOtpVerify: ICreatorOtpVerify) {
    const useStyles:any = makeStyles({
        input: {
          '& input[type=number]': {
            '-moz-appearance': 'textfield', // Hide spinner in Firefox
          },
          '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none', // Hide spinner in Chrome, Safari, Edge, Opera
            margin: 0,
          },
        },
      });
    const classes = useStyles();
    const { userPayload, getVerifyOtp, resendOtpApi } = creatorOtpVerify;
    const accountType = getSessionStoreage("accountType");
    const otpExpireTime = getSessionStoreage("otpExpireTime");
    const BackBtn = styled(IconButton)(({ theme }) => {
        return {
            position: "absolute",
            top: "-15%",
            marginTop: "24px",
            left: "-30%",
            [theme.breakpoints.down(1025)]: {
                top: "-18%",
                left: "-13%",
            },
            [theme.breakpoints.down(395)]: {
                top: "-16%",
                left: "-13%",
            },
        };
    });

    const [timerActive, setTimerActive] = useState<boolean>(false);
    const [isOtpSend, setIsOtpSend] = useState(false);
    const [remainingTime, setRemainingTime] = useState<number>(0);
    const intervalRef: any = useRef(null);

    const startTimer = (otpExpireTime: number) => {
        setRemainingTime(otpExpireTime);
        setTimerActive(true);

        intervalRef.current = setInterval(() => {
            setRemainingTime((prevTime: number) => {
                if (prevTime === 1) {
                    setTimerActive(false);
                    clearInterval(intervalRef.current);
                }
                return prevTime - 1;
            });
        }, 1000);
    };

    const resetTimer = (otpExpireTime: number) => {
        setTimerActive(false);
        clearInterval(intervalRef.current);
        setRemainingTime(otpExpireTime);
    };

    const initialValues = {
        otp: "",
    };

    const verifyOtpSchemaValidation = () => {
        const verifyOtpSchema = {
            otp: Yup.string()
            .required("This field is required")
            .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
            .length(6, "OTP must be exactly 6 digits")
        };
        return Yup.object().shape(verifyOtpSchema);
    };

    const handleSubmit = (data: typeof initialValues) => {
        const allData = { ...userPayload, otp: +data.otp };
        getVerifyOtp(allData, accountType);
    };

    const handleResend = async () => {
        // Todo need to add api here
        const resendData = {
            email: userPayload.email,
            otpType: "register",
        };
        try {
            await resendOtpApi(resendData);

            resetTimer(otpExpireTime * 60);
            startTimer(otpExpireTime * 60);

            setIsOtpSend(true);
        } catch (error) {
            setIsOtpSend(false);
        }
    };
    useEffect(() => {
        startTimer(otpExpireTime * 60);

        return () => {
            clearInterval(intervalRef.current as NodeJS.Timeout);
        };
    }, []);



    return (
        <Box sx={{ position: "relative" }}>
            <BackBtn
                onClick={() =>
                    history.push(
                        `/auth/signup?account-type=${accountType}`
                    )
                }
            >
                <KeyboardBackspace
                    sx={{
                        color: "common.black",
                    }}
                />
            </BackBtn>
            <AuthTitle variant='h4' fontWeight='bold'>
                OTP Verification
            </AuthTitle>
            <AuthSubtitle variant='body1'>
                Please enter the One-Time Password (OTP) to verify
                your account.
            </AuthSubtitle>
            <AuthSubtitle variant='body1'>
            Please enter the OTP sent to your email address
                <Typography color='#1A1A1A' fontWeight={400}>
                    {userPayload?.email}
                </Typography>
            </AuthSubtitle>
            <Formik
                initialValues={initialValues}
                validationSchema={verifyOtpSchemaValidation()}
                onSubmit={handleSubmit}
                enableReinitialize
                validateOnBlur
            >
                {({
                    handleSubmit,
                }: FormikProps<typeof initialValues>) => (
                    <form
                        onSubmit={(
                            e: React.FormEvent<HTMLFormElement>
                        ) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                    >
                        <AuthInput
                            variant='standard'
                            label='OTP'
                            name='otp'
                            autoFocus
                            type='number'
                            className={classes.input}
                            
                        />
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                           {timerActive? <Typography
                                color='#1A1A1A'
                                fontWeight='400'
                                m='16px 0 24px'
                            >
                                {" "}
                                {formatTime(remainingTime)}
                            </Typography>:<Typography m='16px 0 24px' color="#EB5757">OTP Expired</Typography>}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography
                                    color='#828282'
                                    variant='body1'
                                    fontWeight='400'
                                    onClick={() => handleResend}
                                >
                                    Didn't receive the code?
                                </Typography>
                                &nbsp;
                                <Typography
                                    onClick={handleResend}
                                    sx={{
                                        cursor: "pointer",
                                        color: "#4211CF",
                                        fontWeight: 400,
                                    }}
                                >
                                    Resend the code
                                </Typography>
                            </Box>
                        </Box>
                        <AuthButton variant='contained' type='submit'>
                            Verify OTP
                        </AuthButton>
                        <FormikErrorFocus
                            offset={0}
                            align='middle'
                            focusDelay={10}
                            ease='linear'
                            duration={500}
                        />
                    </form>
                )}
            </Formik>
        </Box>
    );
}

export default connect(
    (state: IState) => ({
        createAccountStatus: state.auth.status,
        userPayload: state.auth.userPayload,
    }),
    {
        getVerifyOtp: getVerifyOtpAction,
        resendOtpApi: resendOtpAction,
    }
)(OtpVerify);
